import { Plus } from "iconoir-react";

import { createIcon } from "../create-icon";

export const IconPlus12Line = createIcon(Plus, 12, "Line");
export const IconPlus16Line = createIcon(Plus, 16, "Line");
export const IconPlus20Line = createIcon(Plus, 20, "Line");
export const IconPlus24Line = createIcon(Plus, 24, "Line");
export const IconPlus32Line = createIcon(Plus, 32, "Line");
export const IconPlus48Line = createIcon(Plus, 48, "Line");
export const IconPlus64Line = createIcon(Plus, 64, "Line");
